/* eslint-disable import/prefer-default-export */
export const stringIsEmpty = (str) => {
    return !str || str.trim().length === 0;
};
